import {
  ChatErrorMessage,
  NotificationMessage,
  ThinkingMessage,
  ToolConfirmationRequestMessage,
  ToolConfirmationResponseMessage,
  UserInterruptMessage,
  createChatEventExtension,
} from '@spotify/plugin-confidence-chat-react';

import { confidenceChatPlugin } from '../plugin';

export const ThinkingEventExtension = confidenceChatPlugin.provide(
  createChatEventExtension({
    id: 'thinking',
    predicate: event => Boolean(event.thinking),
    render: event => {
      const thinking = event.thinking;
      if (!thinking) return null;
      return <ThinkingMessage content={thinking.content} />;
    },
  }),
);

export const ToolConfirmationRequestEventExtension =
  confidenceChatPlugin.provide(
    createChatEventExtension({
      id: 'tool-confirmation-request',
      predicate: event => Boolean(event.toolConfirmationRequest),
      render: event => {
        const request = event.toolConfirmationRequest;
        if (!request) return null;
        return (
          <ToolConfirmationRequestMessage
            eventName={event.name}
            tool={request.tool}
            displayName={request.displayName}
            input={request.input}
          />
        );
      },
    }),
  );

export const ToolConfirmationResponseEventExtension =
  confidenceChatPlugin.provide(
    createChatEventExtension({
      id: 'tool-confirmation-response',
      predicate: event => Boolean(event.toolConfirmationResponse),
      render: event => {
        const response = event.toolConfirmationResponse;
        if (!response) return null;
        return <ToolConfirmationResponseMessage decision={response.decision} />;
      },
    }),
  );

export const NotificationEventExtension = confidenceChatPlugin.provide(
  createChatEventExtension({
    id: 'notification',
    predicate: event => Boolean(event.notification),
    render: event => {
      const notification = event.notification;
      if (!notification) return null;
      return <NotificationMessage notification={notification} />;
    },
  }),
);

export const UserInterruptEventExtension = confidenceChatPlugin.provide(
  createChatEventExtension({
    id: 'user-interrupt',
    predicate: event => Boolean(event.userInterrupt),
    render: () => <UserInterruptMessage />,
  }),
);

export const ChatErrorEventExtension = confidenceChatPlugin.provide(
  createChatEventExtension({
    id: 'chat-error',
    predicate: event => Boolean(event.error),
    render: event => {
      const error = event.error;
      if (!error) return null;
      return <ChatErrorMessage {...error} />;
    },
  }),
);
